import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Pictogram from '../../global/pictogram';
import TranslatedCopy from '../../../intl/translated-copy';
import { sendRecoverPinPasswordMetric } from '../../../utilities/metricas-user-profile';

let UserProfileRecoverPasswordSuccess = (props) => {
  const {
    dispatch,
    descriptionCopyId,
    onBackButtonClick,
    titleCopyId,
  } = props;

  const description = descriptionCopyId ? descriptionCopyId : 'PRO_HOME_NEW_PASSWORD_DESCRIPTION';
  const title = titleCopyId ? titleCopyId : 'PRO_HOME_NEW_PASSWORD_CONFIRMATION_TITLE';

  useEffect(() => {
    const type = titleCopyId ? 'nip' : 'pass';
    sendRecoverPinPasswordMetric({ dispatch, type });
  }, []);

  return (
    <div className='UserProfileRecoverPasswordSuccess'>
      <button
        className='UserProfileRecoverPasswordOrPin-back'
        onClick={ onBackButtonClick }
        type='button'>
        <span className='Icon Icon--calendarArrowLeft' />
        <TranslatedCopy
          className='UserProfileRecoverPasswordOrPin-back-Text'
          copyID='PRO_HOME_FORGOT_LOGIN'
        />
      </button>
      <div className='UserProfileRecoverPasswordSuccess-modal-container'>
        <div className='UserProfileRecoverPasswordSuccess-modal'>
          <div className='UserProfileRecoverPasswordSuccess-warn-container'>
            <div className='UserProfileRecoverPasswordSuccess-warn-details'>
              <div className='UserProfileRecoverPasswordSuccess-imgcontainer'>
                <span className='Icon Icon--key UserProfileRecoverPasswordSuccess-img' />
              </div>
              <Pictogram
                className='UserProfileRecoverPasswordSuccess-crossimg'
                id='CircleOnNew' />
              <TranslatedCopy
                className='UserProfileRecoverPasswordSuccess-message'
                copyID={ title }
                tagName='h1'
              />
            </div>
          </div>
          <div className='UserProfileRecoverPasswordSuccess-modal-email'>
            <TranslatedCopy
              className='UserProfileRecoverPasswordSuccess-email'
              copyID={ description }
              tagName='h1'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = function(state) {
  return {
    dispatch: state.dispatch,
  };
};
UserProfileRecoverPasswordSuccess = connect(mapStateToProps)(UserProfileRecoverPasswordSuccess);
export default UserProfileRecoverPasswordSuccess;
